import React from "react";
import "./Services.css";
import { FaRegCalendarAlt, FaBuilding, FaUsers, FaChartLine } from "react-icons/fa";

const services = [
  {
    title: "Executive & Admin Support",
    description: "Calendar & inbox management, CRM updates, data entry & document organization.",
    icon: <FaRegCalendarAlt className="service-icon" />,
  },
  {
    title: "Real Estate Assistance",
    description: "Managing property listings, scheduling appointments, researching market trends.",
    icon: <FaBuilding className="service-icon" />,
  },
  {
    title: "Sales & Lead Generation",
    description: "Prospecting clients, managing outreach campaigns, organizing CRM leads.",
    icon: <FaUsers className="service-icon" />,
  },
  {
    title: "Digital Marketing & Social Media",
    description: "Scheduling posts, running email campaigns, tracking analytics & engagement.",
    icon: <FaChartLine className="service-icon" />,
  },
];

const Services = () => {
  return (
    <section className="services-container">
      <h2 className="services-title">Services I Offer</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            {service.icon}
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;